import { render } from "./modalProdutosComponent.vue?vue&type=template&id=218798b8&scoped=true"
import script from "./modalProdutosComponent.vue?vue&type=script&lang=js"
export * from "./modalProdutosComponent.vue?vue&type=script&lang=js"

import "./modalProdutosComponent.vue?vue&type=style&index=0&id=218798b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-218798b8"]])

export default __exports__